export default "__VITE_ASSET__acc999e0__"